var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBoxBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.548 8.891 3.726 1.855v3.084a1.065 1.065 0 0 0 2.128 0v-2.024l4.23 2.105v9.419L2.548 18.22V8.891zm1.258-1.75 9.88-5.006 3.043 1.616-9.564 5.061L3.806 7.14zm19.31 0-9.431 4.917L9.509 9.98 19 4.956l4.115 2.184zm1.175 1.786v9.307l-9.531 5.059v-9.395l9.531-4.97zm1.022-3.03L19.58 2.856a.979.979 0 0 0-.134-.072L14.642.233A2.081 2.081 0 0 0 12.758.22L1.562 5.892A2.055 2.055 0 0 0 .42 7.74v10.517c0 .788.437 1.497 1.141 1.849l11.203 5.676a2.073 2.073 0 0 0 1.884-.021L25.31 20.1a2.06 2.06 0 0 0 1.109-1.83V7.727a2.06 2.06 0 0 0-1.107-1.83z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoxBlack);
export default __webpack_public_path__ + "static/media/icon_box_black.0666f624e17378664aca5345e4306193.svg";
export { ForwardRef as ReactComponent };